import React from 'react';
import ConnectUsersViewModalBase from './connectUsersViewBase';

const { CONNECT_USERS_VIEW_MESSAGES } = require("./controlPanelConfig");

export default function ConnectUsersViewModal(props){
    return (
        <ConnectUsersViewModalBase
            {...props}
            messages={CONNECT_USERS_VIEW_MESSAGES.ko}
        />
    );
}
